import React from "react";
import Layout from "../Landing/Layout";
import developmentDivision from "../Landing/assets/development-division.png";
import landServices from "../Landing/assets/land-services.png";
import marketingStrategy from "../Landing/assets/marketing-strategy.png";
import capitalMarket from "../Landing/assets/capital-market.png";
import marketingCampaigns from "../Landing/assets/marketing-campaigns.png";
import pmcDivision from "../Landing/assets/pmc-division.png";
import franchiseDivision from "../Landing/assets/franchise-division.png";
import valuationDivision from "../Landing/assets/valuation-division.png";
import universityDivision from "../Landing/assets/university-division.png";

const divisions = [
  {
    title: "Development Division",
    description: "Supports developers across project planning, structuring, and execution readiness.",
    image: developmentDivision,
    imagePosition: "left",
  },
  {
    title: "Land & Developer Services Division",
    description: "Advisory and transaction support for land aggregation, developer alignment, and feasibility coordination",
    image: landServices,
    imagePosition: "right",
  },
  {
    title: "Project Marketing Division",
    description: "Mandate-led project distribution, channel strategy, and absorption execution across markets.",
    image: marketingStrategy,
    imagePosition: "left",
  },
  {
    title: "Capital Market Transactions Division",
    description: "Advisory support for investor transactions, structured deals, and large-ticket opportunities.",
    image: capitalMarket,
    imagePosition: "right",
  },
  {
    title: "Marketing, Advertising & Production Division",
    description: "Centralized creative, branding, campaign execution, and sales enablement for mandate projects.",
    image: marketingCampaigns,
    imagePosition: "left",
  },
  {
    title: "Project Management Consultancy (PMC) Division",
    description: "Oversight, coordination, and execution support across project lifecycles.",
    image: pmcDivision,
    imagePosition: "right",
  },
  {
    title: "Franchise Business Division",
    description: "Partner onboarding, territory management, systems deployment, and operational support.",
    image: franchiseDivision,
    imagePosition: "left",
  },
  {
    title: "Valuation Division",
    description: "Structured valuation, pricing advisory, and financial alignment support.",
    image: valuationDivision,
    imagePosition: "right",
  },
  {
    title: "University Division",
    description: "Professional training, masterclasses, certification programs, and continuous learning for partners.",
    image: universityDivision,
    imagePosition: "left",
  },
];

const Divisions = () => {
  return (
    <Layout>
      <section className="page-hero">
        <div className="section-container animate-fade-in-up">
          <div className="grid-12">
            <div className="lg:col-span-10 lg:col-start-2 text-center">
              <h1 className="heading-display mb-8">A Multi-Engine Real Estate Ecosystem</h1>

              <div className="space-y-6 text-measure mx-auto">
                <p className="body-text">
                  Douglas & McCartney operates a multi-engine real estate ecosystem designed to create multiple income streams under one brand umbrella.
                </p>
                <p className="body-text">
                  This structure allows partners to participate across advisory, execution, distribution, and institutional services.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-shell section-band section-divider">
        <div className="section-container">
          <div className="space-y-16">
            {divisions.map((division, index) => (
              <div key={index} className="grid-12 items-center">
                {division.image && (
                  <div className={`image-frame shadow-card lg:col-span-6 ${division.imagePosition === "right" ? "md:order-2" : "md:order-1"}`}>
                    <img
                      src={division.image}
                      alt={division.title}
                      className="w-full h-auto"
                      loading="lazy"
                      decoding="async"
                      sizes="(max-width: 1024px) 100vw, 50vw"
                    />
                  </div>
                )}

                <div className={`content-card shadow-card lg:col-span-6 ${!division.image ? "md:col-span-2 max-w-2xl mx-auto" : ""} ${division.imagePosition === "right" ? "md:order-1" : "md:order-2"}`}>
                  <h2 className="heading-subsection heading-mid mb-4">{division.title}</h2>
                  <p className="body-text text-muted-foreground">{division.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-shell section-surface section-divider">
        <div className="section-container">
          <div className="grid-12">
            <div className="lg:col-span-8 lg:col-start-3 text-center">
              <p className="heading-subsection text-measure mx-auto font-semibold">
                This ecosystem allows partners to access multiple income streams within one integrated platform, rather than relying on a single brokerage function.
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Divisions;
